import { EntityStatusDesc } from '../../../models/entity.model'
import { SelectionData } from '../../../models/util.model'
import { PermissionsScope } from '../../policies/policy.model'
import { OrderExportAmazonShipData } from '../models/order.entity'
import { Coverage, OrderFieldGroup } from '../models/order.types'

export const ORDER_SCOPE: PermissionsScope = 'orders'
export const ORDER_FRAGMENT = 'order'
export const ORDER_FRAGMENT_PICKING_LIST = 'pickingListId'

export const ORDER_AMAZON_SHIP_EXPORT_DATA_INITIAL_STATE: OrderExportAmazonShipData =
  {
    channelId: undefined,
    startDate: new Date(),
    endDate: new Date(),
    email: '',
  }

export const ORDER_TRANSPORTS = [
  {
    code: 'SENDER',
    name: 'Sender',
  },
  {
    code: 'RECIPIENT',
    name: 'Recipient',
  },
  {
    code: 'CARRIER',
    name: 'Carrier',
  },
]

export const COVERAGE_TYPES: EntityStatusDesc<Coverage>[] = [
  {
    code: 'AVAILABLE',
    name: 'Coverage available',
  },
  {
    code: 'UNAVAILABLE',
    name: 'Coverage unavailable',
  },
  {
    code: 'PARTIAL',
    name: 'Partial',
  },
  {
    code: 'PL-ASSIGNED',
    name: 'Assigned m',
  },
]

export const ORDER_FIELD_GROUPS: SelectionData<OrderFieldGroup>[] = [
  {
    value: 'CARRIER',
    label: 'Corriere',
    icon: 'fad fa-shipping-fast',
  },
]

export const ORDER_SYSTEM_TAGS: string[] = [
  '#alert-peso',
  '#customized',
  '#has-meta',
  '#needs-shipment',
  '#shipment-requested',
]
